"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (date) {
    return date.toISOString().slice(11, 19);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/dateToUTCTimeString.js
// module id = 56
// module chunks = 0